import { call, put } from 'redux-saga/effects';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  updateReportFieldsFailure,
  updateReportFieldsSuccess,
} from '../actions';
import { updateReportFields } from '../api';
import { UpdateReportFieldsRequestAction } from '../types';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateReportFieldsSaga(action: UpdateReportFieldsRequestAction) {
  try {
    let err: ApiError | null;
    const { dataLogId, reference, returnTax } = action.payload;
    console.debug('[updateReportFields][saga] received action', {
      dataLogId,
      reference,
      returnTax,
    });

    const response: ApiResponse = yield call(
      updateReportFields,
      dataLogId,
      reference,
      returnTax
    );
    console.debug('[updateReportFields][saga] api response', response);
    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    yield put(updateReportFieldsSuccess());
  } catch (error: any) {
    console.debug('[updateReportFields][saga] error', error);
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateReportFieldsFailure());
  }
}
